import { useEffect } from 'react';
import useListenFromRn from '../utilities/useListenFromRn';
import useAppDetails from '../utilities/useAppDetails';
import useAppSettings, { AppConfigKeys } from '../admin/useAppSettings';
export default function useCheckAppVersion() {
  const {
    useRNHandler
  } = useListenFromRn();
  const {
    setBlockAppVersion,
    appVersion,
    setAppVersion
  } = useAppDetails();
  const {
    appConfig
  } = useAppSettings();
  useRNHandler('BUILD_VERSION', payload => {
    console.log('BUILD_VERSION', payload);
    try {
      payload = JSON.parse(payload);
    } catch (_) {
      //
    }
    if (payload) {
      setAppVersion(payload);
      if ((appConfig === null || appConfig === void 0 ? void 0 : appConfig[AppConfigKeys.appVersion]) && (appConfig === null || appConfig === void 0 ? void 0 : appConfig[AppConfigKeys.appVersion]) !== (payload === null || payload === void 0 ? void 0 : payload.version)) {
        setBlockAppVersion(true);
      }
    }
  });
  useEffect(() => {
    if ((appConfig === null || appConfig === void 0 ? void 0 : appConfig[AppConfigKeys.appVersion]) && (appVersion === null || appVersion === void 0 ? void 0 : appVersion.version) !== (appConfig === null || appConfig === void 0 ? void 0 : appConfig[AppConfigKeys.appVersion])) {
      setBlockAppVersion(true);
    }
  }, [appConfig, appVersion]);
  return {
    appVersion
  };
}